<template>
    <v-card class="pt-4 pl-2 pr-2 pb-2">
        <v-row class="pl-3 pr-3">
            <v-col>
                <h2>transactions </h2>
            </v-col>
            <v-col> 
                <router-link to="/dashboard/transactions">
                    <v-btn  class="float-right" size="x-small"
                    color="primary">
                    see all
                </v-btn>
                </router-link>
            </v-col>
        </v-row>

        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            Name
                        </th>
                        <th class="text-left">
                            transaction ID
                        </th>
                        <th class="text-left">
                            Amount (₦)
                        </th>
                        <th class="text-left">
                            Amount ($)
                        </th>
                        <th class="text-left">
                            Date
                        </th>
                        <th class="text-left">
                            transaction Type
                        </th>
                        <th class="text-left">
                            Status
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in mytransactions" :key="item.id">
                        <td>{{ item.firstname + ' ' + item.lastname }}</td>
                        <td>{{ item.reference }}</td>

                        <td>{{ formatMoney(item.naira_amount) }}</td>
                        <td>{{ formatMoney(item.dollar_amount) }}</td>
                        <td>{{ item.created | moment("dddd, MMMM Do YYYY") }}</td>
                        <td>{{ item.slug }}</td>
                        <td>
                            <v-chip v-if="item.status === 'approved'" class="ma-2" color="success">
                                {{ item.status }}
                            </v-chip>
                            <v-chip v-else class="ma-2" color="primary">
                                {{ item.status }}
                            </v-chip>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
// =========== IMPORT SERVICE =========
import {formatMoney} from '@/utils/moneyFormatter';

export default {
    data() {
        return {

        }
    },
    props: {
        mytransactions: Array
    },

    mounted() {

    },
    methods: {
        showDetails() {
        },
        formatMoney(amount) {
            return formatMoney(amount, false);
        }
    }
}
</script>

<style>
v-simple-table {
    width: 100vw
}
</style>